module.exports = __webpack_public_path__ + "img/login.350b4779.png";